const getDateWithoutHours = (date) => new Date((new Date(date)).setHours(0, 0, 0, 0)).getTime();

export default getDateWithoutHours;
